/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_Roll_Up_2Inputs */



/**
* | output |
* | --- |
* | "Roll-Up 2" |
*
* @param {Caption_Style_Roll_Up_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_roll_up_2 = /** @type {((inputs?: Caption_Style_Roll_Up_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_Roll_Up_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Défilement 2")
	if (locale === "de") return /** @type {LocalizedString} */ ("Roll-Up 2")
	if (locale === "it") return /** @type {LocalizedString} */ ("Roll-Up 2")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Roll-Up 2")
	if (locale === "es") return /** @type {LocalizedString} */ ("Roll-Up 2")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Roll-Up 2")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロールアップ2")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रोल-अप 2")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enrole 2")
	return /** @type {LocalizedString} */ ("Roll-Up 2")
});